import PolicyDocumentView from "../../components/public/PolicyDocumentView";

export default function PrivacyPolicy() {
  return <PolicyDocumentView slug="privacy-policy" fallbackTitle="Privacy Policy" />;
}
